<template>
  <section>
    <div class="article">
        <Adsense
          data-ad-client="ca-pub-8143206471999291"
          data-ad-slot="2064057101">
        </Adsense>
        <div class="columns">
          <div class="column is-8">
            <img :src="this.article.eye_catching.url" alt="">
            <h1 v-if="this.article"><span class="article_title">{{ article.title }}</span></h1>
            <div v-if="this.article" class="article_foreward" v-html="article.foreword"></div>
            <ul class="toc_lists">
              <p class="toc_index">目次</p>
              <li :class="`toc_list ${item.name}`" v-for="item in toc" :key="item.id">
                <a href="#" v-scroll-to="`#${item.id}`">
                    {{ item.text }}
                  </a>
              </li>
            </ul>
            <div v-if="this.article" class="article_content" v-html="article.content"></div>
            <p v-if="!this.article && this.relate_articles[0].totalCount == 0">該当する記事がありません</p>
            <Adsense
              data-ad-client="ca-pub-8143206471999291"
              data-ad-slot="9159948493">
            </Adsense>
          </div>
          <div class="column">
            <p>キーワード検索</p>
            <SearchComponent/>
            <p class="theme_side">よく見る夢</p>
            <ThemesComponent/>
            <div class="side_ad">
              <Adsense
                data-ad-client="ca-pub-8143206471999291"
                data-ad-slot="3701076989">
              </Adsense>
            </div>
          </div>
        </div>
    </div>
  </section>
</template>

<script>
import axios from "axios"
import store from '@/store'
import cheerio from 'cheerio'
import SearchComponent from '@/components/SearchComponent'
import ThemesComponent from '@/components/ThemesComponent.vue'
export default {
  components: {
    SearchComponent,
    ThemesComponent,
  },
  data() {
    return {
      article: null,
      toc: null
    };
  },
  watch: {
    '$route' (to) {
        store.commit('start');
        this.$router.go(to.params.id)
    }
  },
  created() {
      store.commit('start')
      let url = "https://dream.microcms.io/api/v1/themes?filters=params[equals]" + this.$route.params.id
        axios
            .get(url, {
            headers: { "X-API-KEY": process.env.VUE_APP_MICRO_CMS }
            })
            .then(res => {
              if(res.data.totalCount != 0){
                this.article = res.data.contents[0]
                this.isSetMeta()
                this.makeToc()
                store.commit('end');
              }else{
                this.isNotSetMeta()
                store.commit('end');
              }
            })
            .catch(err => {
            console.log(err);
            store.commit('end');
        });
  },
  methods:{
    isSetMeta(){
      const title = this.article.title.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'')  + "【夢占い】｜夢占い辞典ゆめみん"
      const description = this.article.description
      const twitter_image = this.article.eye_catching.url
      const og_image = this.article.eye_catching.url
      document.title = title
      document.querySelector("meta[property='og:image']").setAttribute('content', og_image)
      document.querySelector("meta[name='twitter:image']").setAttribute('content', twitter_image)
      document.querySelector("meta[property='og:title']").setAttribute('content', title)
      document.querySelector("meta[name='description']").setAttribute('content', description)
      document.querySelector("meta[property='og:description']").setAttribute('content', description)
    },
    isNotSetMeta(){
      const title = "「" + this.$route.params.id + "」" + "の夢の意味は？【夢占い】｜夢占い辞典ゆめみん"
      const description = "「" + this.$route.params.id+ "」"  + "の夢の意味は？"
      const twitter_image = 'https://dream.ameneko.com/ogpImage.jpeg'
      const og_image = 'https://dream.ameneko.com/topImage.jpeg'
      document.title = title
      document.querySelector("meta[property='og:image']").setAttribute('content', og_image)
      document.querySelector("meta[name='twitter:image']").setAttribute('content', twitter_image)
      document.querySelector("meta[property='og:title']").setAttribute('content', title)
      document.querySelector("meta[name='description']").setAttribute('content', description)
      document.querySelector("meta[property='og:description']").setAttribute('content', description)   
    },
    makeToc(){
      const $ = cheerio.load(this.article.content);
      const headings = $('h1, h2, h3').toArray();
      this.toc = headings.map(data => ({
        text: data.children[0].data,
        id: data.attribs.id,
        name: data.name
      }));
    },
  }
}
</script>

<style scoped>
.article{
  padding:20px;
}
.article_foreward{
  margin-bottom: 40px;
}
.toc_index{
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 1.1em;
}
.toc_lists{
    list-style: none;
    background-color: #f7f7fc;
    padding: 20px;
    margin-bottom: 40px;
}
.toc_list{
    padding: 5px 0;
    border-bottom: 1px solid #e7e7f3;
}
.toc_list.h3{
  margin-left: 25px;
  font-size: .9em;
}
.toc_list:hover {
    color: #157DF0;
    cursor: pointer;
    cursor: hand;
    }
h1{
  font-weight: bold;
  font-size: 1.7em;
  padding-bottom: 10px;
  padding-top: 10px;
}
div >>> h2{
  font-weight: bold;
  font-size: 1.4em;
  margin: 40px 0 20px;
  background-color: #eee;
  padding: 10px 20px;
  border-radius: 5px;
}
div >>> h3{
  font-weight: bold;
  font-size: 1.2em;
  margin: 36px 0 16px;
  border-bottom: 1px solid #ddd;
}
div >>> li{
  padding: 4px;
  margin: 0 0 0 20px;
}

div >>> ul, ol {
  list-style: disc;
  margin-top:10px;
  margin-bottom:10px;
  color: #1e366a;
  border: dotted #1e366a 1px;/*ドット 色 太さ*/
  padding: 0.5em 0.5em 0.5em 2em;
}

div >>> ul li, ol li {
  line-height: 1.5;
  padding: 0.5em 0;
}
.theme_side{
  font-weight: bold;
  font-size: 1.2em;
  border-bottom: solid 2px #27556A;
  margin: 20px 0 20px 0;
}
</style>